import { Link } from "react-router-dom";
import { Rating } from "react-simple-star-rating";
import Slider from "react-slick";
import { Card, Col } from "reactstrap";
import { H5, Image, P } from "../../../../AbstractElements";
import { CustomerReviewTitle } from "../../../../Constants/Constants";
import { CustomerReviewData, CustomerReviewOptions } from "../../../../Data/General/Dashboard/Default";
import { dynamicImage } from "../../../../Utils";
import DashboardCommonHeader from "../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";

const CustomerReview = () => {
  return (
    <Col xxl="3" lg="4" sm="6" className="box-col-4">
      <Card className="review-slider">
        <DashboardCommonHeader title={CustomerReviewTitle} dropdownClass="dropdown-toggle" />
        <div className="card-body">
          <div className="owl-carousel owl-theme" id="owl-carousel-dashboard">
            <Slider {...CustomerReviewOptions} >
              {CustomerReviewData.map((item, index) => (
                <div className="item review" key={index}>
                  <div>
                    <Image className="img-fluid" src={dynamicImage(item.image)} alt="" />
                    <div className="review-content">
                      <Link to={`${process.env.PUBLIC_URL}/applications/users/user-profile`}>
                        <H5 className="txt-primary f-w-600">{item.title}</H5>
                      </Link>
                      <span>{item.text}</span>
                    </div>
                    <Rating className="ms-1" fillColor={"#FFAE1A"} initialValue={Math.random() * 5} size={16} />
                    <P>{item.content}</P>
                    <span className="txt-secondary f-w-500">{item.date}</span>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </Card>
    </Col>
  );
};

export default CustomerReview;
